export default __webpack_public_path__ + "static/media/laboratorio.8b8df365.jpg";